import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../../core';
import { Transportadora } from '../transportadora';
import { TransportadoraFilter } from '../filter';
import { TransportadoraSearchAsync } from '../transportadora-search-async';

@Injectable({
    providedIn: 'root'
})
export class TransportadoraCrudHttpService implements Crud<Transportadora> {
    resource = 'transportadora';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as transportadora cadastradas */
    search(): Observable<Transportadora[]> {
        return this.crudService.search<Transportadora>(this.resource);
    }


    searchWithFilter(filter: TransportadoraFilter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<TransportadoraSearchAsync> {
       // Params
       let params = new HttpParams()
                        .append('drawDatatable', drawDatatable.toString())
                        .append('offset', offset.toString())
                        .append('limit', limit.toString())
                        .append('orderBy', orderBy.toString())
                        .append('orderByDir', orderByDir ? orderByDir : '');

        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(this.pathApi, {params});
    }

    /** Procura uma única transportadora através do seu ID */
    find(id: number): Observable<Transportadora> {
        return this.crudService.find<Transportadora>(this.resource, id);
    }

    /** Carrega uma única transportadora através do seu ID */
    load(id: number): Observable<Transportadora> {
        return this.crudService.load<Transportadora>(this.resource, id);
    }

    /** Insere uma nova transportadora */
    insert(entity: Transportadora): Observable<Transportadora> {
        return this.crudService.insert<Transportadora>(this.resource, entity);
    }

    /** Altera uma transportadora existente */
    update(entity: Transportadora): Observable<Transportadora> {
        return this.crudService.update<Transportadora>(this.resource, entity);
    }

    /** Exclui uma transportadora através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
